import { WASTE_EXCHANGE_TYPE } from "../../../domain/WasteExchangeType";
import { formatWasteExchangeContainerName } from "../../../_helpers/wasteExchangeContainerName";

/**
 * Próbuje dopasować pobrane kwity wagowe do wasteExchanges na podstawie kodu odpadu.
 */
export function matchTicketsToExchanges(tickets, wasteExchanges) {
  if (!wasteExchanges || wasteExchanges.length === 0) {
    return tickets;
  }
  // Zbieramy dostępne exchanges (każdy może być użyty tylko raz)
  const available = [...wasteExchanges];

  return tickets.map((ticket) => {
    const ticketWasteCode = ticket.externalData.wastes[0]?.wasteCode; // np. "15 01 01"
    const matchIndex = available.findIndex(
      (exchange) => exchange.wastes.some((w) => w.code === ticketWasteCode)
    );
    if (matchIndex === -1) return ticket;

    const exchange = available[matchIndex];
    available.splice(matchIndex, 1);

    const exchangeType = exchange.isContainer
      ? WASTE_EXCHANGE_TYPE.CONTAINER_EXCHANGE
      : WASTE_EXCHANGE_TYPE.LOADING;

    const wasteExchange =
      exchangeType === WASTE_EXCHANGE_TYPE.CONTAINER_EXCHANGE
        ? {
            wasteExchangeId: exchange.wasteExchangeId,
            orderExchangeContainerName: formatWasteExchangeContainerName(exchange),
          }
        : {
            wasteExchangeId: exchange.wasteExchangeId,
            orderExchangeContainerName: "Załadunek",
          };

    // Dla każdego towaru z exchange szukamy masy z kwitu na podstawie kodu odpadu.
    // Jeśli na kwicie jest dokładnie jeden towar o danym kodzie - używamy jego masy.
    // Jeśli nie ma żadnego lub jest ich więcej niż jeden - wasteMass = null.
    const updatedWastes = exchange.wastes.map((waste) => {
      const matchingTicketWastes = ticket.externalData.wastes.filter(
        (w) => w.wasteCode === waste.code
      );

      const wasteMass =
        matchingTicketWastes.length === 1
          ? (matchingTicketWastes[0].weightNet / 1000).toFixed(4)
          : 0.0000;

      return {
        ...waste,
        wasteId: waste.wasteId,
        wasteFormType: waste.wasteFormType,
        displayDescription: waste.displayDescription,
        wasteKindId: waste.wasteKindId,
        wasteKindName: waste.wasteKindName,
        wasteEntityId: waste.wasteKindId ?? waste.wasteId,
        wasteMass
      };
    });

    return {
      ...ticket,
      exchangeType,
      wasteExchange,
      wastes: updatedWastes,
    };
  });
}
